export const sortFieldMap: Record<string, string> = {
  doctor_index: 'title',
  phone_index: 'title',
  event_index: 'startDate',
  internal_department_index: 'title',
  content_page_index: 'title',
};

import { SearchSortConfig } from 'app/core/services/elasticsearch.service';

const lobbyNoSearchSortFields: Record<string, string[]> = {
  doctor_index: ['title'],
  internal_department_index: ['title'],
  event_index: ['startDate'],
  phone_index: ['title'],
  content_page_index: ['title'],
};

export function getLobbySortConfig(indexName: string, hasSearchText: boolean): SearchSortConfig | undefined {
  const indexKey = Object.keys(sortFieldMap).find((key) => indexName.includes(key));
  if (!indexKey) return undefined;

  const secondaryField = sortFieldMap[indexKey];

  if (hasSearchText) {
    return { sortByScore: true, fields: [secondaryField] };
  }

  return { sortByScore: false, fields: lobbyNoSearchSortFields[indexKey] ?? [secondaryField] };
}

export function getLobbyHeaderKeyByIndex(index: string): string {
  const mapping: Record<string, string> = {
    doctor_index: 'LOBBY.DOCTORS_RESULT_TITLE',
    phone_index: 'LOBBY.PHONE_RESULT_TITLE',
    event_index: 'LOBBY.EVENT_RESULT_TITLE',
    internal_department_index: 'LOBBY.CLINICS_RESULT_TITLE',
  };

  return mapping[index.toLowerCase()];
}

export const displayNameMap: Record<string, (item: any) => string> = {
  TypeId: item => item.typeText,
  Hospital: item => item.hospitalName,
  SubjectId: item => {
    if (Array.isArray(item.subjectText)) {
      return item.subjectText.join(', ');
    }
    return item.subjectText || '';
  },
  SubSubjectId: item => {
    if (Array.isArray(item.subSubjectText)) {
      return item.subSubjectText.join(', ');
    }
    return item.subSubjectText || '';
  },
  EventId: item => item.eventText,
  AudienceId: item => item.audienceText,
  InterestId: item => item.interestText,
  Departments: item => item.departments,
  PhoneFilter1: item => item.phoneFilter1,
  PhoneFilter2: item => item.phoneFilter2,
  PhoneFilter3: item => item.phoneFilter3
};